import { ensureTrailingSlash } from './url'

export interface AuthorizeUrlParams {
  clientId: string
  redirectUri: string
  responseType?: string
  scope?: string
  state?: string
  codeChallenge?: string
  codeChallengeMethod?: string
  extraParams?: Record<string, string>
}

const AUTHORIZE_PATH = 'connect/authorize'

export function buildAuthorizeUrl(authority: string, params: AuthorizeUrlParams): string {
  if (!params.clientId) {
    throw new Error('buildAuthorizeUrl: "clientId" is required')
  }
  if (!params.redirectUri) {
    throw new Error('buildAuthorizeUrl: "redirectUri" is required')
  }
  // code_challenge_method determines how the caller derived codeChallenge from their
  // code_verifier (plain vs. SHA256). Guessing a default here would silently break the
  // token exchange later if it doesn't match what the caller actually computed.
  if (params.codeChallenge && !params.codeChallengeMethod) {
    throw new Error(
      'buildAuthorizeUrl: "codeChallengeMethod" is required when "codeChallenge" is provided',
    )
  }

  const url = new URL(AUTHORIZE_PATH, ensureTrailingSlash(authority))

  url.searchParams.set('response_type', params.responseType ?? 'code')
  url.searchParams.set('client_id', params.clientId)
  url.searchParams.set('redirect_uri', params.redirectUri)

  if (params.scope) {
    url.searchParams.set('scope', params.scope)
  }
  if (params.state) {
    url.searchParams.set('state', params.state)
  }
  if (params.codeChallenge) {
    url.searchParams.set('code_challenge', params.codeChallenge)
    url.searchParams.set('code_challenge_method', params.codeChallengeMethod!)
  }

  for (const [key, value] of Object.entries(params.extraParams ?? {})) {
    url.searchParams.set(key, value)
  }

  return url.toString()
}
